/**
 * Query params for the admin Users list.
 *
 * Users is the staff directory; parents are managed on the Clients page.
 * With no role picked we therefore leave parents out. Picking "Parent"
 * still lists them, so the account can be found here if needed.
 */
export function buildUserListParams({
  page,
  perPage,
  roleFilter = "",
  statusFilter = "",
  searchQuery = "",
}) {
  const params = { skip: (page - 1) * perPage, limit: perPage };
  if (roleFilter) params.role = roleFilter;
  else params.exclude_role = "parent";
  if (statusFilter !== "") params.is_active = statusFilter === "true";
  if (searchQuery) params.search = searchQuery;
  return params;
}
